import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

// プロジェクトID（テーブルプレフィックス / s3-upload の x-project-id に使用）
export const PROJECT_ID = '1cfcb9a7-5410-444f-8143-602b7e61a697';
export const TABLE_PREFIX = '1cfcb9a7';
export const NEWS_TABLE = `${TABLE_PREFIX}_news`;
export const BLOG_TABLE = `${TABLE_PREFIX}_blog`;
export const MEDIA_TABLE = `${TABLE_PREFIX}_media`;
export const S3_UPLOAD_URL = 'https://debuqhzswiqcosjkuktw.supabase.co/functions/v1/s3-upload';
export const GET_CONTACT_INQUIRIES_URL =
  'https://debuqhzswiqcosjkuktw.supabase.co/functions/v1/get-contact-inquiries';
export const UPDATE_CONTACT_CONFIG_URL =
  'https://debuqhzswiqcosjkuktw.supabase.co/functions/v1/update-contact-config';
export const CONTACT_CONFIG_TABLE = 'contact_form_configs';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
  },
});